import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=3d7bc7e4&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=3d7bc7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7bc7e4",
  null
  
)

export default component.exports